import React, { useEffect, useRef, useState } from "react";
import "../Components/Herosectionpage.css";
import dayjs from "dayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { DesktopTimePicker } from "@mui/x-date-pickers/DesktopTimePicker";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import markerIcon from "leaflet/dist/images/marker-icon.png";
import markerShadow from "leaflet/dist/images/marker-shadow.png";
import "../Components/Herosectionpage.css";
import { useNavigate } from "react-router-dom";
import "../Components/Herosectionpage.css";
import { PiMapPinAreaBold, PiMapPinAreaFill } from "react-icons/pi";
import CancelIcon from "@mui/icons-material/Cancel";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconUrl: markerIcon,
  shadowUrl: markerShadow,
});

const Mapboxpage = () => {
  const mapRef = useRef(null);
  const mapInstance = useRef(null);
  const markerRef = useRef(null);
  const pickupWrapperRef = useRef(null);
  const dropWrapperRef = useRef(null);
  const navigate = useNavigate();
  const [pickup, setPickup] = useState("");
  const [drop, setDrop] = useState("");
  const [tripType, setTripType] = useState("transfer");
  const [activeField, setActiveField] = useState(null);
  const [suggestions, setSuggestions] = useState([]);
  const [showMap, setShowMap] = useState(false);
  const [selectingFor, setSelectingFor] = useState(null);
  const [pickupCoords, setPickupCoords] = useState(null);
  const [dropCoords, setDropCoords] = useState(null);
  const [date, setDate] = React.useState(dayjs());
  const [time, setTime] = useState(dayjs());
  const [hours, setHours] = useState("");
  const mapContainerRef = useRef(null);
  useEffect(() => {
    if (!showMap) return;

    if (!mapRef.current) return;
    if (mapInstance.current) return;
    const defaultLat = 21.4858;
    const defaultLng = 39.1925;
    const map = L.map(mapRef.current, {
      zoomControl: true,
      attributionControl: false,
    }).setView([defaultLat, defaultLng], 12);
    L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
      attribution: "",
    }).addTo(map);

    mapInstance.current = map;
    const getAddress = async (lat, lng) => {
      try {
        const res = await fetch(
          `https://nominatim.openstreetmap.org/reverse?format=jsonv2&lat=${lat}&lon=${lng}&accept-language=en`
        );
        const data = await res.json();
        return data.display_name || "Selected Location";
      } catch (err) {
        toast.error(err);
        return "Selected Location";
      }
    };
const setMarkerWithAddress = async (lat, lng) => {
  try {
    if (!map) return;

    const container = map.getContainer?.();
    if (!container) return;

    const address = await getAddress(lat, lng);

    if (markerRef.current && map.hasLayer(markerRef.current)) {
      map.removeLayer(markerRef.current);
    }

    const marker = L.marker([lat, lng], {
      draggable: true,
    }).addTo(map);

    marker.bindPopup(address).openPopup();

    marker.on("dragend", async (e) => {
      const pos = e.target.getLatLng();

      const updatedAddress = await getAddress(
        pos.lat,
        pos.lng
      );

      marker.setPopupContent(updatedAddress).openPopup();
    });

    markerRef.current = marker;
  } catch (error) {
    console.error("Marker Error:", error);
  }
};
    map.on("click", (e) => {
      const { lat, lng } = e.latlng;
      setMarkerWithAddress(lat, lng);
    });
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (pos) => {
          const lat = pos.coords.latitude;
          const lng = pos.coords.longitude;
          map.setView([lat, lng], 14);
          setMarkerWithAddress(lat, lng);
        },
        (err) => {
          console.log(err);
          setMarkerWithAddress(defaultLat, defaultLng);
        }
      );
    } else {
      setMarkerWithAddress(defaultLat, defaultLng);
    }

    return () => {
      if (mapInstance.current) {
        mapInstance.current.remove();
        mapInstance.current = null;
      }
    };
  }, [showMap]);

  useEffect(() => {
    const fetchSuggestions = async () => {
      if (!activeField) return;
      const query = activeField === "pickup" ? pickup : drop;
      if (!query || query.length < 3) {
        setSuggestions([]);
        return;
      }
      try {
        const res = await fetch(
          `https://nominatim.openstreetmap.org/search?format=json&q=${query}&addressdetails=1&limit=5`
        );
        const data = await res.json();
        setSuggestions(data);
      } catch (err) {
        toast.error(err);
      }
    };
    const timer = setTimeout(fetchSuggestions, 500);
    return () => clearTimeout(timer);
  }, [pickup, drop, activeField]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        showMap &&
        mapContainerRef.current &&
        !mapContainerRef.current.contains(event.target)
      ) {
        setShowMap(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside, openMapFor);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside, openMapFor);
    };
  }, [showMap]);

  useEffect(() => {
    const handleDropdownOutside = (event) => {
      const clickedOutsidePickup =
        pickupWrapperRef.current &&
        !pickupWrapperRef.current.contains(event.target);

      const clickedOutsideDrop =
        dropWrapperRef.current &&
        !dropWrapperRef.current.contains(event.target);

      if (clickedOutsidePickup && clickedOutsideDrop) {
        setActiveField(null); // close dropdown
        setSuggestions([]);
      }
    };

    document.addEventListener("mousedown", handleDropdownOutside);
    return () => {
      document.removeEventListener("mousedown", handleDropdownOutside);
    };
  }, []);
  const selectSuggestion = (item) => {
    const coords = {
      lat: Number(item.lat),
      lng: Number(item.lon),
    };
    if (activeField === "pickup") {
      setPickup(item.display_name);
      setPickupCoords(coords);
    } else {
      setDrop(item.display_name);
      setDropCoords(coords);
    }
    setActiveField(null);
    setSuggestions([]);
  };
  const openMapFor = (type) => {
    setSelectingFor(type);
    setActiveField(null);
    setShowMap(true);
  };
  const handleConfirm = () => {
    if (!mapInstance.current) return;
    if (!markerRef.current) {
      toast.success("Select location on map");
      return;
    }
    const { lat, lng } = markerRef.current.getLatLng();
    const address =
      markerRef.current.getPopup()?.getContent() || "Selected Location";
    if (selectingFor === "pickup") {
      setPickup(address);
      setPickupCoords({ lat, lng });
    } else {
      setDrop(address);
      setDropCoords({ lat, lng });
    }
    setShowMap(false);
  };
  const handleSearch = () => {
    if (!pickup) return toast.warning("Pickup required");
    if (tripType === "hour by hour" && !hours) {
      return toast.warning("Please select duration");
    }
    if (tripType !== "hour by hour" && !drop) {
      return toast.warning("Drop required");
    }
    navigate("/bookingpage", {
      state: {
        tripType,
        pickup,
        drop,
        date,
        time,
        hours,
        pickupCoords,
        dropCoords,
      },
    });
  };
  return (
    <>
      <ToastContainer position="top-right" autoClose={2000} />
      <div className="booking-wrapper">
        <div className="bkn">
          <div className="trip-type">
            {["transfer", "hour by hour", "city to city"].map((type) => (
              <div
                key={type}
                className={`trip-option ${tripType === type ? "active" : ""
                  }`}
                onClick={() => setTripType(type)}
              >
                {type}
              </div>
            ))}
          </div>
          <div ref={pickupWrapperRef} className="pickup-wrapper" >
            <input
              value={pickup}
              onFocus={() => setActiveField("pickup")}
              onChange={(e) => {
                setPickup(e.target.value);
                setPickupCoords(null);
              }}
              placeholder="Pickup location"
              className="bkn-input"
            />
            {pickup && (
              <CancelIcon
                onClick={() => {
                  setPickup("");
                  setPickupCoords(null);
                  setSuggestions([]);
                }}
                className="clear-icon"
              />
            )}
            {activeField === "pickup" && (
              <div
                className="pickup-dropdown"
                style={{
                  position: "absolute",
                  top: "100%",
                  left: 0,
                  right: 0,
                  background: "#fff",
                  border: "1px solid #ddd",
                  maxHeight: "280px",
                  overflowY: "auto",
                  zIndex: 999,
                }}
              >
                {suggestions?.length > 0 ? (
                  suggestions?.map((item) => (
                    <div
                      key={`${item.place_id}-${item.lat}`}
                      onClick={() => selectSuggestion(item)}
                      style={{
                        padding: "8px",
                        cursor: "pointer",
                        borderBottom: "1px solid #eee",
                      }}
                    >
                      <PiMapPinAreaFill size={25} /> &nbsp; {item.display_name}
                    </div>
                  ))
                ) : pickup.length >= 3 ? (
                  <div style={{ padding: "8px", color: "#888" }}>
                    No results found
                  </div>
                ) : null}
                <div
                  onClick={() => openMapFor("pickup")}
                  style={{
                    padding: "12px",
                    cursor: "pointer",
                    background: "#f9f9f9",
                    fontWeight: "bold",
                    fontSize: "18px",
                    fontFamily: "Tajawal, sans-serif",
                  }}
                >
                  &nbsp;   <PiMapPinAreaBold size={22} /> &nbsp;&nbsp;
                  Choose from map
                </div>
              </div>
            )}
          </div>
          {tripType === "hour by hour" ? (
            <div
              ref={dropWrapperRef}
              className="pickup-wrapper"
              style={{ position: "relative" }}
            >
              <select
                value={hours ? JSON.stringify(hours) : ""}
                onChange={(e) => {
                  const selected = JSON.parse(e.target.value);
                  setHours(selected);
                }}
                className="bkn-input"
              >
                <option value="">Select duration</option>
                {[...Array(24)].map((_, i) => {
                  const h = i + 1;
                  const optionData = {
                    hours: h,
                    km: h * 40,
                    label: `${h} Hour${h > 1 ? "s" : ""} (incl. ${h * 40} km)`,
                  };
                  return (
                    <option key={h} value={JSON.stringify(optionData)}>
                      {optionData.label}
                    </option>
                  );
                })}
              </select>
            </div>
          ) : (
            <div ref={dropWrapperRef} className="pickup-wrapper" style={{ position: "relative" }}>
              <input
                value={drop}
                onFocus={() => setActiveField("drop")}
                onChange={(e) => {
                  setDrop(e.target.value);
                  setDropCoords(null); // reset coords if typing again
                }}
                placeholder="Drop location "
                className="bkn-input"
              />
              {drop && (
                <CancelIcon
                  onClick={() => {
                    setDrop("");
                    setDropCoords(null);
                    setSuggestions([]);
                  }}
                  className="clear-icon"
                />
              )}
              {activeField === "drop" && (
                <div
                  className="pickup-dropdown"
                  style={{
                    position: "absolute",
                    top: "100%",
                    left: 0,
                    right: 0,
                    background: "#fff",
                    border: "1px solid #ddd",
                    maxHeight: "280px",
                    overflowY: "auto",
                    zIndex: 999,
                  }}
                >
                  {suggestions?.length > 0 ? (
                    suggestions?.map((item) => (
                      <div
                        key={item.place_id}
                        onClick={() => selectSuggestion(item)}
                        style={{
                          padding: "8px",
                          cursor: "pointer",
                          borderBottom: "1px solid #eee",
                        }}
                      >
                        <PiMapPinAreaFill size={20} color="blue" />{item.display_name}
                      </div>
                    ))
                  ) : drop?.length >= 3 ? (
                    <div style={{ padding: "8px", color: "#888" }}>
                      No results found
                    </div>
                  ) : null}
                  <div
                    onClick={() => openMapFor("drop")}
                    style={{
                      padding: "12px",
                      cursor: "pointer",
                      background: "#f9f9f9",
                      fontWeight: "bold",
                      fontSize: "18px",
                      fontFamily: "Tajawal, sans-serif",
                    }}
                  >
                    &nbsp;   <PiMapPinAreaBold size={22} /> &nbsp;&nbsp;
                    Choose from map
                  </div>
                </div>
              )}
            </div>
          )}
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              label="Date "
              value={date}
              onChange={(newValue) => setDate(newValue)}
              slotProps={{
                textField: {
                  fullWidth: true,
                  sx: {
                    width: {
                      xs: "100%",
                      sm: "100%",
                      md: "160px",
                    },
                    "& .MuiInputLabel-root": {
                      color: "black",
                      fontFamily: "Tajawal, sans-serif",
                      fontSize: "19px"
                    },
                    "& .MuiInputLabel-root.Mui-focused": {
                      color: "#000000",
                    },

                    "& .MuiInputBase-root": {
                      height: "75px",
                      borderRadius: "12px",
                    },
                    "& .MuiOutlinedInput-notchedOutline": {
                      borderColor: "#fd0b0b",
                    },
                    "&:hover .MuiOutlinedInput-notchedOutline": {
                      borderColor: "#f00909",
                    },
                    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                      borderColor: "#000000",
                    },
                  },
                },
              }}
            />
          </LocalizationProvider>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DesktopTimePicker
              label="Time "
              value={time}
              onChange={(newValue) => setTime(newValue)}
              slotProps={{
                textField: {
                  fullWidth: true,
                  sx: {
                    width: {
                      xs: "100%",
                      sm: "100%",
                      md: "160px",
                    },

                    "& .MuiInputLabel-root": {
                      color: "black",
                      fontFamily: "Tajawal, sans-serif",
                      fontSize: "19px"
                    },

                    "& .MuiInputLabel-root.Mui-focused": {
                      color: "#000000",
                    },

                    "& .MuiInputBase-root": {
                      height: "74px",
                      borderRadius: "12px",
                    },
                    "& .MuiOutlinedInput-notchedOutline": {
                      borderColor: "#fd0b0b",
                    },
                    "&:hover .MuiOutlinedInput-notchedOutline": {
                      borderColor: "#f00909",
                    },
                    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                      borderColor: "#000000",
                    },
                  },
                },
              }}
            />
          </LocalizationProvider>
          <button className="bkn-btn" onClick={handleSearch}>
            Search
          </button>
        </div>
        {showMap && (
          <div className="map-container">
            <div ref={mapContainerRef}>
              <div ref={mapRef} className="map-box"></div>
              <div className="map-footer">
                <button
                  className="bkn-btn confirm"
                  onClick={handleConfirm}
                >
                  Confirm Location
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  )
}

export default Mapboxpage
